import PropTypes from 'prop-types';
import { isNil, noop } from 'lodash/fp';
import { Button, ButtonVariant } from 'app/components/core/Button';
import { useFormContext } from './Form.jsx';

export const Cancel = ({ children = 'Cancel', onClick = noop, ...buttonProps }) => {
    const context = useFormContext();

    if (isNil(context)) {
        throw new Error('<Cancel> must be used within a <Form> component');
    }

    const { resetAllFields } = context;
    const handleClick = (...args) => {
        resetAllFields();
        onClick(...args);
    };

    return (
        <Button variant={ButtonVariant.SECONDARY} onClick={handleClick} {...buttonProps}>
            {children}
        </Button>
    );
};

Cancel.propTypes = {
    /** The label content of the cancel button. */
    children: PropTypes.node,
    onClick: PropTypes.func
};
